<script lang="ts" setup>
import { defineProps } from 'vue';

import { modalService } from '@exchange/libs/modals/src';
import SubaccountSelectModal from '@exchange/libs/trading-accounts/ui/src/lib/components/modals/SubaccountSelectModal.vue';

const props = defineProps({
  isFuturesMarket: { type: Boolean, required: true },
});

const selectSubaccount = () => {
  const modalKey = modalService.show(
    SubaccountSelectModal,
    {
      isFuturesMarket: props.isFuturesMarket,
    },
    {
      selectSubaccount: () => {
        modalService.hide(modalKey);
      },
      cancelModal: () => {
        modalService.hide(modalKey);
      },
    },
    { canClose: true, centered: true, variant: 'dark' },
  );
};
</script>

<template>
  <div class="market-mismatch-overlay">
    <p class="market-mismatch-overlay__message">
      {{ isFuturesMarket ? $t('ui.marketMismatch.FUTURES.text') : $t('ui.marketMismatch.SPOT.text') }}
    </p>
    <x-button
      class="market-mismatch-overlay__button"
      variant="primary"
      :text="$t('ui.marketMismatch.action')"
      @click="selectSubaccount"
    />
  </div>
</template>

<style lang="scss">
.market-mismatch-overlay {
  position: absolute;
  z-index: var(--market-mismatch-overlay-z-index);
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgb(var(--v-theme-overlay-2));
  opacity: 1;
  transition: opacity 200ms ease-out;

  &__message {
    padding: 0 10px;
    margin-bottom: 16px;
    color: rgb(var(--v-theme-text-primary));
    font-size: var(--font-size-md);
    text-align: center;
  }

  &__button {
    width: calc(70% - 20px);
  }
}
</style>
